export const LocationFilterButton = ({ object, index, isActive, handleClick, ...props }) => {
    return <div key={object.Location}>
        <button
            className={isActive ? "active" : ""}
            id={index}
            value={object.Location}
            onClick={() => handleClick(object.Location, index)}
        >
            {object.Location}
            <span>{`(${object.Count})`}</span>
            <i
                className="fa fa-close"
                id={index}
                value={object.Location}
                onClick={() => handleClick(object.Location, index)}
            ></i>
        </button>
    </div>;
}